module.exports = __webpack_public_path__ + "MX.png?a648480d8859ee53dbdd0a266695f81f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/MX.png
// module id = 385
// module chunks = 0